import React from "react";
function SearchComp() {
  return (
    <div className="search__container">
      <input className="search__input" type="text" placeholder="Search" />
    </div>
  );
}

export default SearchComp;
